import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DragulaService } from 'ng2-dragula';

import { SLLayer } from 'src/app/model/sl-layer';
import { COMPARE, COMPARESTR, Comparisons } from 'src/app/types/@types/comparisons';
import { AttributeInfo, CriterionParam } from 'src/app/types/@types/sl-v-types';

@Component({
  selector: 'app-search-criteria-list',
  templateUrl: './search-criteria-list.component.html',
  styleUrls: ['./search-criteria-list.component.scss']
})
export class SearchCriteriaListComponent implements OnInit {

  @Input() criteria: Array<CriterionParam> = [];
  @Input() fields: Array<AttributeInfo> = [];
  @Input() layer: SLLayer;


  @Output() change = new EventEmitter<SearchCriteriaListComponent>();

  constructor(private cdr: ChangeDetectorRef) { }
  private init = false;
  private id = 0;
  ngOnInit(): void {
    this.init = true;
  }
  DeleteAll() {
    this.criteria.splice(this.criteria.length);
  }
  AddCriteria(newCriterion?: CriterionParam): CriterionParam {

    this.id += 1;

    const criterion: any = !!newCriterion ? newCriterion : {
      andor: 'and',
      compare: COMPARESTR.HAS,
      field: this.fields[0].name,
      val: ''
    };
    criterion.id = this.id;
    //this.criteria.push(criterion);
    this.change.emit(this);
    this.Refresh();
    return criterion;
  }
  NameToField(fieldName: string): AttributeInfo {
    for (const field of this.fields) {
      if (field.name === fieldName) {
        return field;
      }
    }
  }

  Delete(criterion: CriterionParam, offset: number) {
    if (this.criteria.length <= offset) return;
    this.criteria.splice(offset, 1);
    this.cdr.markForCheck();
    this.change.emit(this);
    this.Refresh();
  }
  Refresh() {
    if (this.init == false) return;
    this.cdr.detectChanges();
  }

}
